export default __webpack_public_path__ + "static/media/damn-chris.f0ac895b.gif";